import { createStore } from 'redux';
import session from './session';

const store = createStore(session);

export default store;

